import { TripBookingTypes } from '../../lib/types/models/trip-booking/trip-booking'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTripBooking(data: TripBookingTypes.Input) {
  return restApiClient
    .url(constructApiUrl(API['trip-bookings'].create.url, null))
    .post<TripBookingTypes.IdOnly, TripBookingTypes.Input>(data)
}
